<template>
  <div>
    <button 
    style="cursor: pointer; background-color: rgb(0,153,255,.7)!important;"
      class="text-white border-transparent btn group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 focus:ring focus:ring-custom-500/30"
      @click.stop="isFormOpened = !isFormOpened">
        <i class="uil uil-envelope"></i> 
        <i style="margin-left: 5px;margin-right: 2px;" class="uil uil-telegram"></i>
        Get notified
      </button>
        <div v-if="isFormOpened">

          <div class="relative z-50 modal" id="modal-id" aria-labelledby="modal-title" role="dialog" aria-modal="true">
              <div class="fixed inset-0 z-50 overflow-hidden">
                  <div class="absolute inset-0 transition-opacity bg-black bg-opacity-50 modal-overlay"></div>
                  <div class="p-4 mx-auto text-center animate-translate sm:max-w-lg">
                      <div class="relative overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl dark:bg-zinc-700">
                          <div class="bg-white dark:bg-zinc-700">
                            <div v-if="pageLoading">
                              <div class="mt-4"></div>
                              <Loader />
                              <div class="mt-4"></div>
                            </div>
                              <div v-else class="p-5 sm:flex sm:items-finish">
                                  <div  class="w-full mt-3 text-center sm:mt-0 ltr:sm:ml-4 rtl:sm:mr-4 ltr:sm:text-left rtl:sm:text-right">
                                      <div class="mt-2">
                                          <h5 class="text-gray-900 dark:text-zinc-100/80" style="font-size: small;">
                                            Get the latest jobs matching your search
                                          </h5>
                                      </div>
                                      <div class="mt-4">
                                          <hr>
                                        </div>
                                        <div class="mt-4">
                                          <!-- Search: Remote selection -->
                                          <div class="filter-search-form mt-lg-0">
                                            
                                              <i class="uil uil-clipboard-notes"></i>
                                              <select class="w-full filter-job-input-box dark:text-gray-100" v-model="this.search.attendanceRequirement" v-on:click="contactFormOpened.telegramOpened = false, contactFormOpened.emailSubscriptionFormOpened = true">
                                                  <option value=null >Working style</option>
                                                  <option v-bind:key="attendanceType" v-for="attendanceType in attendanceTypes" :value="attendanceType">{{ attendanceType }}</option>
                                              </select>
                                          </div>
                                        </div>
    
                          <div class="mt-2 filter-search-form mt-lg-0">
                                <i class="uil uil-clipboard-notes"></i>

                                        <!-- Search: ContractType selection -->
                                          <select 
                                           class="w-full filter-job-input-box dark:text-gray-100" 
                                           v-model="this.search.contractType" 
                                           v-on:click="contactFormOpened.telegramOpened = false, contactFormOpened.emailSubscriptionFormOpened = true">
                                            <option value=null>Contract type</option>
                                            <option v-bind:key="contractType" v-for="contractType in contractTypes" :value="contractType" >{{ contractType }}</option>
                                          </select>
                                        </div>

                          <div class="mt-2 filter-search-form mt-lg-0">
                            <multiselect 
                                v-on:click="contactFormOpened.telegramOpened = false, contactFormOpened.emailSubscriptionFormOpened = true"
                                class="filter-job-input-box-custom"
                                v-model="this.search.tags" 
                                :options="options" 
                                :searchable="false" 
                                :multiple="true" 
                                :close-on-select="false" 
                                :clear-on-select="true"              
                                :preserve-search="false" 
                                placeholder="Select skills" 
                                :select-label="'Tap to select'"
                                :deselect-label="'Tap to remove'"
                                label="" 
                                track-by="" 
                                :preselect-first="false">
                                <template #selection="{ values, isOpen }" 
                                >
                                    <span class="multiselect__single filter-job-input-box-custom dark:text-gray-200 "
                                        v-if="values.length"
                                        v-show="!isOpen">
                                        {{ values.length }} skills selected: 
                                        <ul class="flex flex-wrap gap-2 mt-2 ">
                                            <li 
                                                class="border p-[6px] border-gray-100/50 rounded group/joblist dark:border-gray-100/20 active "
                                                v-bind:key="tag" 
                                                v-for="tag in this.search.tags" >
                                                <div class="flex items-center ">
                                                  <a href="javascript:void(0)" 
                                                      class="dark:border-gray-100/20">
                                                      <h6 class="pxmt-1 text-sm font-medium text-gray-700 dark:text-gray-50">
                                                        {{ tag }}
                                                      </h6>
                                                  </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </span>
                                </template>
                            </multiselect>  
                                        </div>

                                        <div class="mt-4 filter-search-form mt-lg-0" v-if="this.search.companyName != null">
                                         <i class="uil uil-clipboard-notes"></i>

                                        <!-- Search: ContractType selection -->
                                          <select class="w-full filter-job-input-box dark:text-gray-100" disabled=true>
                                            <option disabled selected value=null >{{this.search.companyName}}</option>
                                          </select>
                                        </div>

                                        <div class="mt-4">
                                          <hr>
                                        </div>
                                        
                                        <div class="mt-4">
                                        <button 
                                          @click.stop="contactFormOpened.telegramOpened = false, contactFormOpened.emailSubscriptionFormOpened = true"
                                          style="width: 50%; cursor: pointer; "
                                          :style= "!contactFormOpened.emailSubscriptionFormOpened ? 'background-color: rgb(0,153,255,.7)!important;' : ''"
                                          class="text-white border-transparent btn group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 focus:ring focus:ring-custom-500/30"
                                          >
                                            <i class="uil uil-envelope"></i> 
                                            Email
                                        </button>
                                        <button 
                                          @click.stop="contactFormOpened.emailSubscriptionFormOpened = false, contactFormOpened.telegramOpened = true, handleTelegramSubcription()"
                                          style=" width: 50%; cursor: pointer;" 
                                          :style= "!contactFormOpened.telegramOpened ? 'background-color: rgb(0,153,255,.7)!important;' : ''"
                                          class="text-white border-transparent btn group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 focus:ring focus:ring-custom-500/30"
                                          >
                                            <i class="uil uil-telegram"></i>
                                            Telegram
                                        </button>
                                      </div>
                                      <div v-if="contactFormOpened.telegramOpened == true">
                                        <div v-if="pageTelegramFormLoading">
                                          <div class="mt-4"></div>
                                          <Loader />
                                          <div class="mt-4"></div>
                                        </div>
                                        <div v-else>
                                          <div class="mt-4 filter-search-form mt-lg-0 p-2">
                                              <p class="text-gray-500 dark:text-gray-300">
                                                1. Find your personal bot at: 
                                                <a :href=this.telegramSubscriptionLink target="blank">https://t.me/thejobtap_bot</a>
                                              </p>
                                          </div>
                                          <div class="mt-2 filter-search-form mt-lg-0 p-2">
                                              <p class="text-gray-500 dark:text-gray-300">
                                                2. Message the following command:
                                              </p>
                                              <p 
                                                class="text-gray-500 dark:text-gray-300 mt-2"
                                                style="cursor:copy"
                                                v-on:click="copyToClipboard(this.telegramSubscriptionCommand)">
                                                {{ this.telegramSubscriptionCommand }} 
                                              </p>
                                          </div>
                                          <!-- <div class="mt-2 mt-lg-0">
                                              <p class="text-gray-500 dark:text-gray-300" style="font-style: italic; font-size: small;">Search command expires in 60 minutes if not activated</p>
                                          </div> -->
                                        <FeedbackNotification class="w-full" v-if="this.telegramNotification.text != ''" 
                                          :feedbackText="this.telegramNotification.text"
                                          :feedbackLevel="this.telegramNotification.level" />
                                        </div>
                                      </div>
                                      <div v-if="contactFormOpened.emailSubscriptionFormOpened == true">
                                        <div v-if="!isEmailSubscriptionFormSubmitted">
                                        <div class="mt-4 filter-search-form mt-lg-0">
                                          <i class="uil uil-envelope"></i>
                                        <!-- Form -->
                                          <!-- <label for="emailInput" class="text-gray-900 dark:text-gray-50">Email</label> -->
                                          <input data-test-key="input-email-subscription-email" 
                                            type="email"
                                            class="w-full filter-job-input-box dark:text-gray-100" 
                                            v-model="state.emailSubscriptionForm.emailAddress"
                                            placeholder="Enter your email"
                                            />
                                          </div>
                                          <div>
                                            <ValidationMessage v-if="v$.emailSubscriptionForm.emailAddress.$error" :validationMessage ="v$.emailSubscriptionForm.emailAddress.$errors[0].$message"/>
                                          </div>
                                          <div class="mt-2 filter-search-form mt-lg-0">
                                            <i class="uil uil-clipboard-notes"></i>
                                            <select data-test-key="input-ddl-email-subscription-frequency" 
                                            class="w-full filter-job-input-box dark:text-gray-100" v-model="state.emailSubscriptionForm.frequencyType">
                                            <option v-bind:key="frequencyType" v-for="frequencyType in emailSubscription.frequencyTypes" :value="frequencyType">{{frequencyType}}</option>
                                            </select>
                                          </div>

                                          <button data-test-key="button-email-subscription-submit" 
                                            class="mt-3 w-full btn group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 border-transparent text-white hover:-translate-y-1.5"
                                            v-on:click="handleEmailSubscription">
                                            Subscribe <i class="uil uil-arrow-right"></i>
                                          </button>
                                      </div>
                                       <FeedbackNotification class="w-full" v-if="this.emailNotification.text != ''" 
                                        :feedbackText="this.emailNotification.text"
                                        :feedbackLevel="this.emailNotification.level" />
                                      </div>
                                </div>
                              </div>
                              <div class="px-4 py-3 bg-gray-100/50 sm:flex ltr:sm:flex-row-reverse sm:px-6 dark:bg-zinc-800">
                                  <button v-on:click="isFormOpened = false" type="button" class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm btn dark:text-gray-100 hover:bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-custom-500/20 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm dark:bg-zinc-700 dark:border-zinc-600 dark:hover:bg-zinc-600 dark:focus:bg-zinc-600 dark:focus:ring-zinc-700 dark:focus:ring-gray-500/20" data-tw-dismiss="modal">Cancel</button>
                                  <!-- <button v-else v-on:click="isFormOpened = false" type="button" class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm btn dark:text-gray-100 hover:bg-gray-50/50 focus:outline-none focus:ring-2 focus:ring-custom-500/20 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm dark:bg-zinc-700 dark:border-zinc-600 dark:hover:bg-zinc-600 dark:focus:bg-zinc-600 dark:focus:ring-zinc-700 dark:focus:ring-gray-500/20" data-tw-dismiss="modal">Continue</button> -->
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

import { jobListingCategoryAPI } from "@/api/jobListingCategory";
import { emailSubscriptionAPI } from "@/api/emailSubscription";
import { telegramSubscriptionAPI } from "@/api/telegramSubscription";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import { reactive, computed } from 'vue' 
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import ValidationMessage from "@/components/ValidationMessage.vue";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import Multiselect from 'vue-multiselect'
import { loadScript } from "vue-plugin-load-script";
import Loader from "@/components/Loader.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

export default{
  name: "EmailSubscriptionForm",
  components : {
    ValidationMessage, FeedbackNotification, Multiselect, Loader
  }, 
  props: ["handleResetForm", "attendanceRequirement", "contractType", "tags", "location", "minSalary", "companyName"],
  setup () {
    const state = reactive({
      emailSubscriptionForm: {
        emailAddress : '',
        frequencyType : 'Daily'
        }
      });
      const rules = computed(() => {
        return {
          emailSubscriptionForm: {
            emailAddress: { required, email },
          }
        }
      })
      const v$ = useVuelidate(rules, state)
      return { state, v$ }
  },
  data() {
    return {
      pageLoading : false, 
      emailNotification : {
        text : "",
        level : "",
      },
      telegramNotification: {
        text : "",
        level : "",
      },
      resetForm : this.handleResetForm,
      isFormOpened : false,
      contactFormOpened :{
        emailSubscriptionFormOpened : true,
        telegramOpened: false
      },
      isEmailSubscriptionFormSubmitted : false,
      emailSubscription :{
        frequencyTypes : ['Daily', 'Weekly', 'Monthly']
      },
      search: { 
        searchTerm: this.searchTerm,
        attendanceRequirement: this.attendanceRequirement,
        tags:  Array.isArray(this.tags) ? this.tags : [ this.tags ],
        minSalary: this.minSalary,
        location: this.location,
        contractType: this.contractType,
        companyName: this.companyName
      },
      salaryBrackets : [10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 110000, 120000],
      contractTypes : ["FullTime", "PartTime", "Contract", "Internship"],
      attendanceTypes : ["Remote", "Hybrid", "Office"],
      jobListingCategories : [],
      value: this.tags,
      options: [],
      telegramSubscriptionIdentifier: 'not set',
      pageTelegramFormLoading: false,
      telegramSubscriptionCommand: '',
      telegramSubscriptionLink: ''
    };
  },
  watch: {
    handleResetForm(e) {
        //alert(this.handleResetForm)
        this.isEmailSubscriptionFormSubmitted = false;
        this.emailNotification.text = '';
        this.emailNotification.level = '';        
        this.telegramNotification.text = '';
        this.telegramNotification.level = '';
        this.contactFormOpened.emailSubscriptionFormOpened = true;
        this.contactFormOpened.telegramOpened = false;
    }
  },
  mounted() {
      this.getJobListingCategories();
  },
  methods: {
     async copyToClipboard(text) {
      await navigator.clipboard.writeText(text);
      this.telegramNotification = { text : "copied to clipboard", level : "success" };

      setTimeout(() => clearInterval(this.telegramNotification.text = ''), 2000);
    },
    async handleEmailSubscription() {

      // validate the form
      this.v$.$validate();
      if(!this.v$.$error)
      {
        this.pageLoading = true;
        const result = await log.catchPromise(() =>
          pageStatus.observe(async () => {
            const result = await emailSubscriptionAPI.create(
              this.state.emailSubscriptionForm.emailAddress, 
              this.search.tags, 
              this.search.companyName, 
              null,
              '',
              this.search.attendanceRequirement,
              this.state.emailSubscriptionForm.frequencyType,
              '',
              this.contractType);
            if (result.data)
            {
              this.emailNotification = { text : "Subscription Added", level : "success" };
              this.isEmailSubscriptionFormSubmitted = true;
              //this.resetForm = false;
            }
          })
        );
        this.pageLoading = false;
        if (!result.success) {
          this.emailNotification = { text : result.data, level : "error" };        
        }    
      }
    },
    async handleTelegramSubcription() {
        
      this.pageTelegramFormLoading = true;
      this.telegramNotification = { text : '', level : "" };        
        
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await telegramSubscriptionAPI.create(
            this.search.tags, 
            this.search.companyName, 
            null,
            '',
            this.search.attendanceRequirement,
            '',
            this.contractType);
          
          if (result.data)
          {
            this.telegramSubscriptionIdentifier = result.data;
            this.telegramSubscriptionCommand = '/subscribe ' + this.telegramSubscriptionIdentifier + ' MySearch1'
            this.telegramSubscriptionLink = 'https://t.me/thejobtap_bot?text=/subscribe ' + this.telegramSubscriptionIdentifier + " MySearch1"
          }
          else
          {
            this.telegramNotification = { text : "Unable to generate a search Id", level : "error" };
          }
        })
      );
      this.pageTelegramFormLoading = false;
      if (!result.success) {
        this.telegramNotification = { text : result.data, level : "error" };   
      }    
    },
    async getJobListingCategories() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategories();
          result.forEach((element) => { 
            this.options.push(element.Name);
            //this.options.push({name: element.Name, jobCount: element.JobListingCount});
          })
          // this.tags.forEach((element) => { 
          //   this.value.push({name: element, jobCount: element.JobListingCount});
          // })
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    }
  },
};

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
